import React from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage1 from "../../assets/img/add/1.png";
import AddImage2 from "../../assets/img/add/2.png";
import AddImage3 from "../../assets/img/add/3.png";
import AddImage4 from "../../assets/img/add/4.png";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Engineering the future with cutting-edge AI solutions and custom software development services.</h1>
            <p className="font13">
              We engineer the future with powerful AI solutions and high-performance custom software designed to help businesses scale and innovate.
Our team builds intelligent, secure, and reliable digital products tailored to your needs.
From AI automation to enterprise-grade applications, we deliver technology that accelerates growth and efficiency.
Partner with us to transform your ideas into impactful, future-ready solutions
            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="ai"
                title="Next-Gen AI & ML Assistants"
                subtitle="Empower your business with next-generation AI assistants and advanced machine learning solutions designed to automate workflows, boost productivity, and drive innovation."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="mobile"
                title="Mobile Application Development"
                subtitle="We build high-performance mobile applications powered by modern UI/UX, scalable architecture, and intelligent AI/ML features to accelerate your business growth."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="web"
                title="Web Design & Development"
                subtitle="We craft fast, responsive, and visually stunning websites with clean UX/UI, scalable architecture, and seamless performance to help your business grow online."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="qa" title="Sofware Quality Assurance" subtitle="Ensure flawless performance with our comprehensive Quality Assurance and software testing services, delivering secure, reliable, and error-free digital solutions." />
            </ServiceBoxWrapper>
             <ServiceBoxWrapper>
              <ServiceBox icon="custom" title="Custom Business Software" subtitle="Transform your business with custom software solutions designed to streamline operations, boost productivity, and scale with your unique needs." />
            </ServiceBoxWrapper>
               <ServiceBoxWrapper>
              <ServiceBox icon="iot" title="Smart IoT Solutions" subtitle="We design, develop, and manage end-to-end IoT solutions—from device connectivity and cloud integration to automation and real-time monitoring. Our IoT services help businesses improve visibility, reduce operational costs, and make smarter decisions powered by data." />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="devops" title="DevOps & Security Testing" subtitle="Optimize your infrastructure with expert DevOps practices and robust security penetration testing to ensure scalable, secure, and high-performing systems." />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold">Access skilled IT professionals to fill talent gaps, accelerate projects, and boost productivity without long-term hiring.</h4>
                <h2 className="font40 extraBold">Flexible Staff Augmentation  Skilled IT Professionals</h2>
                <p className="font12">
                 Our Staff Augmentation services provide skilled, on-demand professionals to seamlessly extend your in-house team. We help businesses scale quickly, fill talent gaps, and accelerate project delivery with experienced specialists, including:
                </p>
                <ul className="font12" style={{ marginTop: "10px" }}>
                  <li>AI/ML engineers and data scientists</li>
                  <li>Full-stack and mobile developers</li>
                  <li>DevOps, cloud, and SRE specialists</li>
                  <li>QA engineers and security testers</li>
                </ul>
                
                
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img src={AddImage1} alt="office" />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={AddImage2} alt="office" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={AddImage3} alt="office" />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={AddImage4} alt="office" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;